module.exports = __webpack_public_path__ + "img/video-play-thumb.1fbd456b.jpg";